import ReactNativeFs from 'react-native-fs';

import platformConfig from '/config/platform.config';
import {recordError} from '/util/console.util';

// RegExp to match both language-only and language+region file names:
// * en.json
// * en-CA.json
const TRANSLATION_FILENAME_REGEXP = new RegExp(
  '^([a-z][a-z](-[A-Z][A-Z])?)\\.json$',
);

export const getAvailableLanguageCodes = () => {
  const processResults = (results = []) => {
    const languageCodes: any = [];

    results.forEach((result = {}) => {
      // @ts-expect-error TS(2339): Property 'name' does not exist on type 'never'.
      const match = (result.name || '').match(TRANSLATION_FILENAME_REGEXP);
      if (match) {
        languageCodes.push(match[1]);
      }
    });

    return languageCodes;
  };

  if (platformConfig.getOS() === 'ios') {
    return ReactNativeFs.readDir(ReactNativeFs.MainBundlePath).then(
      // @ts-expect-error TS(2345): Argument of type '(results?: never[]) => any' is n... Remove this comment to see the full error message
      processResults,
    );
  } else {
    // @ts-expect-error TS(2345): Argument of type '(results?: never[]) => any' is n... Remove this comment to see the full error message
    return ReactNativeFs.readDirAssets('custom').then(processResults);
  }
};

export const readTranslationFile = (languageCode: any) => {
  const processFileString = (fileString: any) => {
    try {
      return JSON.parse(fileString);
    } catch (err) {
      recordError(
        err,
        `unable to parse translation file for "${languageCode}".`,
      );
      return null;
    }
  };

  const handleError = (err: any) => {
    if (languageCode !== 'en') {
      recordError(
        // @ts-expect-error TS(2554): Expected 0-2 arguments, but got 3.
        Error`unable to read translation file for "${languageCode}", ${err}`,
      );
    }
    return null;
  };

  if (platformConfig.getOS() === 'ios') {
    const filePath = `${ReactNativeFs.MainBundlePath}/${languageCode}.json`;
    return ReactNativeFs.readFile(filePath)
      .then(processFileString)
      .catch(handleError);
  } else {
    const filePath = `custom/${languageCode}.json`;
    return ReactNativeFs.readFileAssets(filePath)
      .then(processFileString)
      .catch(handleError);
  }
};
